import { EntityBase } from "./EntityBase";
import { User } from "./User";
import { Company } from "./Company";
import { FuelType } from "./FuelType";
import { Offer } from "./Offer";
import { SellerContract } from "./SellerContract";
import { RateClass } from "./RateClass";
import { LoadZone } from "./LoadZone";


export class SellOffer extends Offer {
    company: Company = null!;
    fuelType: FuelType = null!;
    rateClasses: RateClass[] = [];
    loadZone: LoadZone = null!;
    sellerContract: SellerContract = null!;
    notes: string = null!;

    constructor(fromOffer?: SellOffer) {
      super();
      if (fromOffer!=null) {
         this.company = fromOffer.company;
         this.fuelType = fromOffer.fuelType;
         this.rateClasses = fromOffer.rateClasses;
         this.loadZone = fromOffer.loadZone;
         this.sellerContract = fromOffer.sellerContract;
         this.notes = fromOffer.notes;

         this.user = fromOffer.user;
         this.utility = fromOffer.utility;
         this.price = fromOffer.price;
         this.termFrom = fromOffer.termFrom;
         this.termPeriod = fromOffer.termPeriod;
         this.validDate = fromOffer.validDate;
      }
    }

    priceForBuyer(): number {
       return (this.price+this.fee);
    }

    priceForSeller(): number {
       return this.price;
    }
}
